import { config, useGetMyUserQuery, ViteMode } from '@consigli/hooks';
import { useAuthContext } from '@consigli/oauth';
import { type FC, type PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { CheckingAuthorization } from './checking-authorization';

export const AdminGuard: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();
  const { session } = useAuthContext();
  const { data: user } = useGetMyUserQuery();

  useEffect(() => {
    if (user == null) return;

    if (!user.isSuperuser && !(config.MODE === ViteMode.PDE && user.isOrgAdmin)) {
      navigate('/access-denied');
      return;
    }
  }, [navigate, user]);

  if (session == null) {
    throw new Error('<AdminGuard> should never render without an already existing session!');
  }

  return user ? <>{children}</> : <CheckingAuthorization />;
};
